export const defaultCredentials = {
  admin: {
    email: 'admin@tsinda.pro',
    password: 'NIJP',
    role: 'admin' as const,
  },
  student: {
    email: 'testuser@gmail.com',
    password: 'user1',
    role: 'student' as const,
  },
};
